import { DaxoSingleFrameIcon } from '@global-engineering-shared/gweb-material-icons-global-next';
import { LabelledSideNavBarItemProps } from '@global-engineering-shared/gweb-material-types';

import { DATA_MANAGEMENT_PAGE_URL, DRAFTS_PAGE_URL, ENTITY_PAGE_URL } from './defaults';

export const getDefaultNavigationItems = (draftsCount: number): LabelledSideNavBarItemProps[] => {
  return [
    {
      items: [
        {
          id: 'daxo-inventory',
          title: 'DAXO Inventory',
          icon: <DaxoSingleFrameIcon titleAccess={'InventoryIcon'} />,
          childItems: [
            {
              id: 'entities',
              title: 'Entities',
              link: ENTITY_PAGE_URL,
            },
            {
              id: 'drafts',
              title: `Drafts (${draftsCount})`,
              link: DRAFTS_PAGE_URL,
            },
            {
              id: 'data-management',
              title: 'Data Management',
              link: DATA_MANAGEMENT_PAGE_URL,
            },
          ],
        },
      ],
    },
  ];
};
